import { render, staticRenderFns } from "./modalAddTeamDeal.vue?vue&type=template&id=680eda24&"
import script from "./modalAddTeamDeal.vue?vue&type=script&lang=js&"
export * from "./modalAddTeamDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports